// extracted by mini-css-extract-plugin
export var container = "styles-module--container--3g0dE";
export var dot = "styles-module--dot--Gp+44";
export var flash = "styles-module--flash--POtj2";